import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import requestApiService from "../../services/requestApi.service";
import Common from "../Common";
import invoice from "./assets/images/invoice.png";
import { Button, Container } from "reactstrap";
import { isAgentAccount, setSessionValue } from "../../Common/Appcommon";
import { useAppContext } from "../../Context/AppContext";

const PaymentCallBack = () => {
    const { status, type } = useParams();
    const { setHeaderNotiMinutes } = useAppContext();
    const location = useLocation();
    const [errorMsg, setErrorMsg] = useState();
    const [loading, setLoading] = useState(true);
    const isAgency = isAgentAccount();

    useEffect(() => {
        if(!status || !type){
            window.location.hash = "#/usage";
        }
        // Extract session_id from the URL query string
        const searchParams = new URLSearchParams(location.search);
        const sessionId = searchParams.get('session_id');
        const info = searchParams.get('info');

        if (sessionId) {
            processSessionData(sessionId, info);
        }
    }, [location.search]);

    const handlePaymentConfirmPage = () => {
        window.location.hash = "/usage";
    }

    const processSessionData = async (session_id, info) => {
        const params = {
            ENTITY: "STRIPE_PROCESSOR",
            OPERATION: "PROCESS_SESSION_DATA",
            session_id: session_id,
            isAgency: isAgency,
            info: info,
            type: type
        };
        setLoading(true);
        let response = await requestApiService.processServerRequest(params);
        if(response.issuccess){
            if(type === "addon"){
                setHeaderNotiMinutes("");
            }
        }
        setLoading(false);
    }

    const paymentSuccess = () => {
        return (
            <Container fluid>
                <div className="no-records-container">
                    <div className="d-grid align-center">
                        {/* <i class="fi fi-ss-badge-check success-tick-icon"></i> */}
                        <img src={invoice} className="w-25" alt="Stripe Logo"></img>
                        <div className="mt-3 font-color">
                            <span className="h3">Success!</span>
                            <br/>
                            <span> Your subscription has been successfully updated.</span>
                        </div>
                        <Button className="theme-bg-g mt-3 payment-scs-btn" style={{"margin": "auto"}} onClick={e => handlePaymentConfirmPage()}>
                            Go to Plan details
                        </Button>
                    </div>
                </div>
            </Container>
        );
    }

    const paymentCancel = () => {
        return (
            <Container fluid>
                <div className="no-records-container">
                    <div className="d-grid align-center">
                        {/* <i class="fi fi-ss-badge-check success-tick-icon"></i> */}
                        <img src={invoice} className="w-25" alt="Stripe Logo"></img>
                        <div className="mt-3 font-color">
                            <span className="h3">Payment Canceled!</span>
                            <br/>
                            <span> Your payment was not completed. You can try again or contact support if you need help.</span>
                        </div>
                        <Button className="theme-bg-g mt-3 payment-scs-btn" style={{"margin": "auto"}} onClick={e => handlePaymentConfirmPage()}>
                        Go to Usage
                        </Button>
                    </div>
                </div>
            </Container>
        );
    }

    return (
        <Fragment>
            <Common
                title={
                    "Payment"
                }
                titleContent={
                    <span>Payment</span>
                }
                mainContent={
                    <Fragment>
                        {
                            status === "success" && 
                            paymentSuccess()
                        }
                        {
                            status === "cancelled" && 
                            paymentCancel()
                        }
                    </Fragment>
                }
                mainLoader={loading}  
            />
        </Fragment>
    )
}

export default PaymentCallBack;